import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { api } from 'src/api';

/** Whether a property utility runs New Submeter: mirrors the backend's submeter_not_configured check (own active template plus at least one mapping of either kind). */
export const isSubmeterConfigured = _ref => {
  let activeCsvColumnMapId = _ref.activeCsvColumnMapId,
    csvMaps = _ref.csvMaps,
    unitMeterMaps = _ref.unitMeterMaps;
  if (!activeCsvColumnMapId) return false;

  // The list is the utility's own templates, so finding the active one there also checks it belongs.
  const activeTemplate = (csvMaps || []).find(map => map.id === activeCsvColumnMapId);
  if (!activeTemplate) return false;
  if ((unitMeterMaps || []).length > 0) return true;
  return (activeTemplate.unitMappings || []).length > 0;
};
const responseOf = envelope => {
  if (!(envelope !== null && envelope !== void 0 && envelope.isSuccessful)) throw new Error('Submeter configuration read failed');
  return envelope.response;
};

/** A cycle that already holds interim submeter charges stays on the interim screens (the backend refuses it cycle_billed_through_interim). */
export const hasInterimCharges = submeterFinalState => Array.isArray(submeterFinalState) && submeterFinalState.length > 0;

/**
 * Whether Process on this cycle opens the Meter details wizard. Reads the API directly, not the store's
 * async actions, which cancel each other's runs. Rejects when a read fails.
 */
export const fetchOpensNewSubmeter = async _ref2 => {
  let propertyUtilityId = _ref2.propertyUtilityId,
    propertyId = _ref2.propertyId,
    utilityId = _ref2.utilityId,
    billingCycleId = _ref2.billingCycleId;
  if (!propertyUtilityId) return false;
  const _await$Promise$all = await Promise.all([api.PropertyUtility.getSubmeterConfigV2({
      propertyUtilityId
    }, {}).then(responseOf), api.Allocations.getSubmeterBillingCsvMaps({
      propertyUtilityId
    }, {}).then(responseOf), api.Allocations.getSubmeterBillingUnitMeterMaps({
      propertyUtilityId
    }, {}).then(responseOf), api.Allocations.postGetSubMeterFinalState({
      propertyId,
      utilityId,
      billingCycleId
    }, {}).then(responseOf)]),
    _await$Promise$all2 = _slicedToArray(_await$Promise$all, 4),
    config = _await$Promise$all2[0],
    csvMaps = _await$Promise$all2[1],
    unitMeterMaps = _await$Promise$all2[2],
    finalState = _await$Promise$all2[3];
  return isSubmeterConfigured({
    activeCsvColumnMapId: config === null || config === void 0 ? void 0 : config.csvColumnMapId,
    csvMaps,
    unitMeterMaps
  }) && !hasInterimCharges(finalState);
};